import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
var render = function render() {
  var _vm$purchaseOrder2, _vm$purchaseOrder3;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": "100%"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Item stocks")])]), _c(VCardText, [_c("div", {
    staticClass: "wine-naming"
  }, [_vm._v(" " + _vm._s(_vm.item.name) + " ")]), _c("router-link", {
    attrs: {
      to: {
        name: "adminStockList",
        query: {
          id_wine: _vm.item.wineId
        }
      },
      target: "_blank"
    }
  }, [_vm._v(" See stocks ")]), _c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      id: "table",
      headers: _vm.headers,
      items: _vm.stocks,
      "hide-default-footer": "",
      "disable-sort": "",
      "loading-text": "Loading... Please wait"
    },
    scopedSlots: _vm._u([{
      key: "item.reference_warehouse",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v(" " + _vm._s(!String.isNullOrEmpty(item.reference_warehouse) ? item.reference_warehouse : item.wine.accountancy_code) + " ")])];
      }
    }, {
      key: "item.quantity",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(_vm._s(item.quantity) + " b.")];
      }
    }, {
      key: "item.quantity_committed",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(!!item.quantity_committed ? item.quantity_committed + " b." : _vm.emptyCellContent) + " ")];
      }
    }, {
      key: "item.warehouse.name",
      fn: function fn(_ref4) {
        var _item$warehouse;
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s((_item$warehouse = item.warehouse) !== null && _item$warehouse !== void 0 && _item$warehouse.name ? item.warehouse.name : _vm.emptyCellContent) + " ")];
      }
    }, {
      key: "item.total_implanted_countries",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(item.countries.length === item.total_implanted_countries ? "All" : item.countries.map(function (x) {
          return x.name;
        }).join(", ")) + " ")];
      }
    }, {
      key: "item.reservation_type",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(item.reservation_type === _vm.stockReservationTypes.DEFAULT.id ? _vm.emptyCellContent : item.reservation_type === _vm.stockReservationTypes.SPECIFIC_CUSTOMER.id ? _vm.getFullNameUser(item.reservation_user) : Object.values(_vm.stockReservationTypes).find(function (x) {
          return x.id === item.reservation_type;
        }).shortListLabel) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref7) {
        var _vm$purchaseOrder;
        var item = _ref7.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "table-actions"
        }, [_c("router-link", {
          attrs: {
            title: "See",
            disabled: !((_vm$purchaseOrder = _vm.purchaseOrder) !== null && _vm$purchaseOrder !== void 0 && _vm$purchaseOrder.id),
            to: {
              name: "adminStockDetails",
              query: {
                id_stock: item.id_stock
              }
            },
            target: "_blank"
          }
        }, [_c("i", {
          staticClass: "fas fa-eye"
        })])], 1)])];
      }
    }], null, true)
  })], 1), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      disabled: !((_vm$purchaseOrder2 = _vm.purchaseOrder) !== null && _vm$purchaseOrder2 !== void 0 && _vm$purchaseOrder2.id),
      to: {
        name: "adminStockDetails",
        query: {
          id_wine: _vm.item.wineId,
          id_po: (_vm$purchaseOrder3 = _vm.purchaseOrder) === null || _vm$purchaseOrder3 === void 0 ? void 0 : _vm$purchaseOrder3.id
        }
      },
      target: "_blank"
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" New Stock ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.reload();
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-sync pr-1"
  }), _vm._v(" Reload stocks ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };